export default {
    defaultLabelXML() {
        return '<?xml version="1.0" encoding="UTF-8"?>\n'
            + '<DieCutLabel Version="8.0" Units="twips">\n'
            + '\t<PaperOrientation>Landscape</PaperOrientation>\n'
            + '\t<Id>Mail</Id>\n'
            + '\t<PaperName>30256 Shipping</PaperName>\n'
            + '\t<DrawCommands>\n'
            + '\t\t<RoundRectangle X="0" Y="0" Width="3331" Height="5760" Rx="180" Ry="180" />\n'
            + '\t\t<RoundRectangle X="2880" Y="2520" Width="180" Height="720" Rx="120" Ry="120" />\n'
            + '\t</DrawCommands>\n'
            + '\t<ObjectInfo>\n'
            + '\t\t<ImageObject>\n'
            + '\t\t\t<Name>Image</Name>\n'
            + '\t\t\t<ForeColor Alpha="255" Red="0" Green="0" Blue="0" />\n'
            + '\t\t\t<BackColor Alpha="0" Red="255" Green="255" Blue="255" />\n'
            + '\t\t\t<LinkedObjectName></LinkedObjectName>\n'
            + '\t\t\t<Rotation>Rotation90</Rotation>\n'
            + '\t\t\t<IsMirrored>False</IsMirrored>\n'
            + '\t\t\t<IsVariable>False</IsVariable>\n'
            + '\t\t\t<ImageLocation/>\n'
            + '\t\t\t<ScaleMode>Uniform</ScaleMode>\n'
            + '\t\t\t<BorderWidth>0</BorderWidth>\n'
            + '\t\t\t<BorderColor Alpha="255" Red="0" Green="0" Blue="0" />\n'
            + '\t\t\t<HorizontalAlignment>Left</HorizontalAlignment>\n'
            + '\t\t\t<VerticalAlignment>Center</VerticalAlignment>\n'
            + '\t\t</ImageObject>\n'
            + '\t\t<Bounds X="0" Y="0" Width="9000" Height="4000" />\n'
            + '\t</ObjectInfo>\n'
            + '</DieCutLabel>';
    },
};
